export const CASE_MATCH_TAG_DELETE_IN_USE_MESSAGE = (tagLabel: string, total: number) =>
  `タグ「${tagLabel}」は${total}件のマッチング情報で使用されています。`;
export const CASE_MATCH_TAG_DELETE_UNASSIGN_MESSAGE = "削除すると、これらのマッチング情報からタグが解除されます。";
export const CASE_MATCH_TAG_DELETE_CONFIRM_MESSAGE = "削除してもよろしいですか？";
export const CASE_MATCH_TAG_DELETE_SIMPLE_CONFIRM_MESSAGE = (tagLabel: string) => `タグ「${tagLabel}」を削除しますか？`;
export const CASE_MATCH_TAG_DELETE_NEWLY_ADDED_MESSAGE =
  "以下のマッチング情報が新たに対象に追加されました。\nご確認のうえ、もう一度「削除する」を押してください。";
